export const Bindings: {
    [key: string]: number
} = {
    'r': 45,
    'e': 43,
    'w': 41,
    'q': 40,
    'a': 47,
    's': 48,
    'd': 49,
    'f': 50,
    'g': 51,
    'h': 52,
    'j': 53,
    'k': 54,
    'l': 55,
    ';': 56,
    '\'': 57,
    '\\': 58,
};